<template>
  <div v-show="state" style="padding-top: 10px" class="col-12">
    <li class="nav-item">
      <button
        class="btn btn-default col-12"
        type="button"
        @click="loadStudetSpecial"
        style="margin-bottom: 5px"
      >
        Estudiantes Habilitados
      </button>
    </li>
  </div>
</template>
<script setup>
const emit = defineEmits(["changeState"]);

const props = defineProps({
  institution: Object,
  state: Boolean,
});

const changeRue = () => {
  emit("changeState");
};
</script>
<style></style>
